<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>
<h3 class="cg-h3">{{ 'am.identify.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-xl">
  {{ 'am.identify.subHeader' | translate }}
</p>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [hiddenSteps]="hiddenSteps$ | async"
  [activeStep]="0"
></cigna-process-steps>

<form
  [formGroup]="usersForm"
  style="max-width: 500px"
  class="cg-margin-bottom-xl"
  data-test="new-user-form"
>
  <div formArrayName="users">
    <div
      *ngFor="
        let user of userControls;
        let i = index;
        last as lastUser;
        first as firstUser
      "
      [formGroupName]="i"
    >
      <div
        style="
          padding-top: 1.5em;
          margin-top: 1.5em;
          border-top: 1px solid #ccc;
        "
      >
        <button
          *ngIf="!(firstUser && lastUser)"
          style="float: right; padding: 0"
          (click)="removeUser(i)"
          [attr.data-test]="'lnk-remove-user'"
          cignaButton="link"
        >
          {{ 'am.identify.form.removeLink' | translate }}
        </button>
        <h4 class="cg-margin-top-none cg-margin-bottom-md">
          {{ 'am.identify.form.fieldsetLabel' | translate }} {{ i + 1 }}
        </h4>

        <div>
          <div class="cg-multiple-field-container">
            <div class="cg-field-container">
              <label
                class="cg-field-container__label"
                for="firstName-{{ i }}"
                >{{ 'am.identify.form.firstNameLabel' | translate }}</label
              >
              <div class="cg-field-container__input-container">
                <input
                  cignaInput
                  type="text"
                  autocomplete="nope"
                  formControlName="firstName"
                  id="firstName-{{ i }}"
                  [attr.data-test]="'txt-first-name-' + i"
                  maxlength="30"
                  style="width: 175px"
                />
              </div>
              <div
                *ngIf="
                  user.controls.firstName.invalid &&
                  user.controls.firstName.touched
                "
                class="cg-error-msg"
                style="max-width: 175px"
              >
                <cigna-icon type="exclamation-circle"></cigna-icon>
                <span>{{ 'am.identify.form.firstNameError' | translate }}</span>
              </div>
            </div>
            <div class="cg-field-container">
              <label class="cg-field-container__label" for="lastName-{{ i }}">{{
                'am.identify.form.lastNameLabel' | translate
              }}</label>
              <div class="cg-field-container__input-container">
                <input
                  cignaInput
                  type="text"
                  autocomplete="nope"
                  formControlName="lastName"
                  id="lastName-{{ i }}"
                  [attr.data-test]="'txt-last-name-' + i"
                  maxlength="50"
                  style="width: 215px"
                />
              </div>
              <div
                *ngIf="
                  user.controls.lastName.invalid &&
                  user.controls.lastName.touched
                "
                class="cg-error-msg"
                style="max-width: 215px"
              >
                <cigna-icon type="exclamation-circle"></cigna-icon>
                <span>{{ 'am.identify.form.lastNameError' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="cg-field-container">
            <label class="cg-field-container__label" for="jobRole-{{ i }}">{{
              'am.identify.form.jobRoleLabel' | translate
            }}</label>
            <div class="cg-field-container__input-container">
              <select
                cignaSelect
                formControlName="jobRole"
                id="jobRole-{{ i }}"
                [attr.data-test]="'cmb-jobrole-' + i"
                autocomplete="nope"
                style="width: 400px"
              >
                <option value="">
                  {{ 'am.identify.form.jobRoleSelectDefault' | translate }}
                </option>
                <option
                  [title]="jobRole.description"
                  *ngFor="let jobRole of jobRoles$ | async"
                  [ngValue]="jobRole.id"
                >
                  {{ jobRole.description }}
                </option>
              </select>
            </div>
            <div
              *ngIf="
                user.controls.jobRole.invalid && user.controls.jobRole.touched
              "
              class="cg-error-msg"
            >
              <cigna-icon type="exclamation-circle"></cigna-icon>
              <span>{{ 'am.identify.form.jobRoleError' | translate }}</span>
            </div>
          </div>

          <div class="cg-multiple-field-container">
            <div class="cg-field-container">
              <div class="cg-field-container__label">
                {{ 'am.identify.form.phoneLabel' | translate }}
              </div>
              <fieldset
                class="cg-field-container__input-container"
                formGroupName="phone"
              >
                <label for="phone-1-{{ i }}" class="cdk-visually-hidden"
                  >Phone number three digit area code</label
                >
                <input
                  style="width: 60px"
                  maxlength="3"
                  cignaInput
                  type="text"
                  autocomplete="nope"
                  formControlName="phone1"
                  id="phone-1-{{ i }}"
                  [attr.data-test]="'txt-phone1-' + i"
                  maxlength="3"
                />
                <span style="margin-left: 3px; margin-right: 3px">-</span>
                <label for="phone-2-{{ i }}" class="cdk-visually-hidden"
                  >Phone number three digit prefix</label
                >
                <input
                  style="width: 60px"
                  maxlength="3"
                  cignaInput
                  type="text"
                  autocomplete="nope"
                  formControlName="phone2"
                  id="phone-2-{{ i }}"
                  [attr.data-test]="'txt-phone2-' + i"
                  maxlength="3"
                />
                <span style="margin-left: 3px; margin-right: 3px">-</span>
                <label for="phone-3-{{ i }}" class="cdk-visually-hidden"
                  >Phone number four digit line number</label
                >
                <input
                  style="width: 70px"
                  maxlength="4"
                  cignaInput
                  type="text"
                  autocomplete="nope"
                  formControlName="phone3"
                  id="phone-3-{{ i }}"
                  [attr.data-test]="'txt-phone3-' + i"
                  maxlength="4"
                />

                <div
                  *ngIf="
                    user.controls.phone.invalid &&
                    user.controls.phone.controls.phone1.touched &&
                    user.controls.phone.controls.phone2.touched &&
                    user.controls.phone.controls.phone3.touched
                  "
                  class="cg-margin-top-sm"
                >
                  <div class="cg-error-msg">
                    <cigna-icon type="exclamation-circle"></cigna-icon>
                    <span>{{ 'am.identify.form.phoneError' | translate }}</span>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="cg-field-container">
              <label class="cg-field-container__label" for="phoneExt-{{ i }}">{{
                'am.identify.form.extLabel' | translate
              }}</label>
              <div class="cg-field-container__input-container">
                <input
                  cignaInput
                  style="width: 70px"
                  type="text"
                  autocomplete="nope"
                  formControlName="phoneExt"
                  id="phoneExt-{{ i }}"
                  [attr.data-test]="'txt-phone-ext-' + i"
                />
              </div>
              <div
                *ngIf="
                  user.controls.phoneExt.invalid &&
                  user.controls.phoneExt.touched
                "
                class="cg-error-msg"
              >
                <cigna-icon type="exclamation-circle"></cigna-icon>
                <span>{{ 'am.identify.form.extError' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="cg-field-container">
            <label class="cg-field-container__label" for="email-{{ i }}">{{
              'am.identify.form.emailLabel' | translate
            }}</label>
            <div class="cg-field-container__input-container">
              <input
                cignaInput
                type="text"
                autocomplete="nope"
                formControlName="email"
                id="email-{{ i }}"
                [attr.data-test]="'txt-user-email-' + i"
                style="width: 250px"
              />
            </div>
            <div
              *ngIf="user.controls.email.invalid && user.controls.email.touched"
              class="cg-error-msg"
            >
              <cigna-icon type="exclamation-circle"></cigna-icon>
              <span>{{ 'am.identify.form.emailError' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="cg-margin-bottom-xl cg-margin-top-lg" #addUserBtn>
  <button cignaButton="secondary" (click)="addUser()" data-test="btn-add">
    {{ 'am.identify.form.addLink' | translate }}
  </button>
</div>

<div style="display: inline-block">
  <cigna-page-step-navigation
    *ngrxLet="jobRoles$ as jobRoles"
    [showPrevious]="false"
    [nextEnabled]="true"
    [showCancel]="true"
    nextButtonLabel="Assign Access"
    (next)="nextScreen(jobRoles)"
  >
  </cigna-page-step-navigation>
</div>

<div
  *ngIf="usersForm.invalid && submitted"
  style="display: inline-block"
  class="cg-margin-left-lg cg-error-msg"
>
  <cigna-icon type="exclamation-circle"></cigna-icon>
  <span>{{ 'am.identify.form.formError' | translate }}</span>
</div>
